import { AgingTourSteps } from "../../components/TourGuide/tourGuideData";
import { useEffect, useRef, useState, Fragment } from "react";
import {
  LiaHornbill,
  LiaSearchPlusSolid,
  LiaSearchSolid,
} from "react-icons/lia";
import { MdClose, MdEdit, MdModeEdit } from "react-icons/md";
import { aging } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import Pagination from "../../common/Pagination";
import ConfirmDeleteModal from "../../common/DeleteModel";
import ErrorModal from "../../common/CustomModel";
import AgingForm from "./AgingForm";
import { HiOutlinePlus } from "react-icons/hi";
import { Button, CalculationFooter } from "../../common/Shared";
import {
  IoIosSave,
  IoMdArrowDropdown,
  IoMdArrowDropright,
} from "react-icons/io";
import { AiOutlineCheck } from "react-icons/ai";
import { IoCloseSharp } from "react-icons/io5";
import { RiHistoryLine } from "react-icons/ri";
import { LayoutGrid, Info } from "lucide-react";
import { formatDate } from "../../utlis/formateDate";
import { RegistryHeader } from "../../common/Shared";
import { TourGuide } from "../../components/TourGuide/TourGuide";

const Aging = () => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const [searchQuery, setSearchQuery] = useState("");
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isAgingData, setIsAgingData] = useState([]);
  const [isQcDoneData, setIsQcDoneData] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const pageSize = 50;

  const [isTourOpen, setIsTourOpen] = useState(false);

  useEffect(() => {
    const hasSeenTour = localStorage.getItem("aluex_aging_tour_seen");
    if (!hasSeenTour) {
      const timer = setTimeout(() => {
        setIsTourOpen(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleTourComplete = () => {
    localStorage.setItem("aluex_aging_tour_seen", "true");
  };


  const [formData, setFormData] = useState({
    aging_No: 0,
    aging_Date: "",
    start_Gas_Reading: "",
    end_Gas_Reading: "",
    total_Consumption: "",
    temperature: "",
    shift: "",
    in_Time: "",
    out_Time: "",
    total_Time: "",
    created_By: userId,
    agingDetails: [
      {
        aging_No: 0,
        seq_No: 0,
        batch_Id: "",
        cut_Length: "",
        quantity: "",
        hardness: "",
        remark: "",
        die_Id: "",
        casting_No: "",
        po_No: "",
      },
    ],
  });
  const [selectedQcData, setSelectedQcData] = useState(null);
  const [isActiveTab, setIsActiveTab] = useState("qc-done");
  const [adding, setAdding] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedSeqs, setSelectedSeqs] = useState([]);
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [editingRows, setEditingRows] = useState(new Set());
  const [draftRows, setDraftRows] = useState({});
  const tableScrollRef = useRef(null);
  const isFetchingRef = useRef(false);
  const [qcHasMore, setQcHasMore] = useState(true);
  const [agingHasMore, setAgingHasMore] = useState(true);
  const [qcPage, setQcPage] = useState(1);
  const [agingPage, setAgingPage] = useState(1);

  const cancelEdit = (id) => {
    setEditingRows((prev) => {
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
    setDraftRows((prev) => {
      const next = { ...prev };
      delete next[id];
      return next;
    });
  };
  const parseTimeToMinutes = (t) => {
    if (!t) return null;
    const [h = 0, m = 0] = String(t).split(":").map(Number);
    return h * 60 + m;
  };

  const parseDurationToMinutes = (v) => {
    if (v === "" || v == null) return null;
    const s = String(v).trim();

    if (s.includes(":")) {
      const [h = 0, m = 0] = s.split(":").map(Number);
      return h * 60 + m;
    }
    const n = Number(s);
    if (Number.isFinite(n)) return Math.round(n * 60);

    return null;
  };

  const minutesToHHMM = (mins) => {
    const m = ((mins % 1440) + 1440) % 1440;
    const h = Math.floor(m / 60);
    const mm = m % 60;
    return String(h).padStart(2, "0") + ":" + String(mm).padStart(2, "0");
  };
  const changeDraft = (id, field, value) => {
    setDraftRows((prev) => {
      const base = prev[id] ?? {};
      const next = { ...base, [field]: value };

      if (field === "start_Gas_Reading" || field === "end_Gas_Reading") {
        const s = Number(next.start_Gas_Reading || 0);
        const e = Number(next.end_Gas_Reading || 0);
        next.total_Consumption = e - s;
      }
      const startMins = parseTimeToMinutes(next.in_Time);
      const durMins = parseDurationToMinutes(next.out_Time);

      if (startMins != null && durMins != null) {
        next.total_Time = minutesToHHMM(startMins + durMins);
      } else {
        next.total_Time = "";
      }
      return { ...prev, [id]: next };
    });
  };

  const toggleExpand = (id) => {
    setExpandedRows((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const fetchAgingData = async (page = 1) => {
    setLoading(true);
    try {
      const res = await aging.getAllAging(page, pageSize);

      setIsAgingData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setAgingHasMore(false);
      }
      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching Aging Data", "error");
    }
    setLoading(false);
  };

  const fetchQcDoneData = async (page = 1) => {
    setLoading(true);
    try {
      const res = await aging.getAllQcDone(page, pageSize);
      setIsQcDoneData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setQcHasMore(false);
      }
      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching Qc Done data", "error");
    }
    setLoading(false);
  };

  const handleTabChange = (tab) => {
    setIsActiveTab(tab);
    if (tab === "qc-done") {
      setQcPage(1);
      setIsQcDoneData([]);
      setQcHasMore(true);
    } else {
      setAgingPage(1);
      setIsAgingData([]);
      setAgingHasMore(true);
    }
  };

  useEffect(() => {
    if (isActiveTab === "qc-done") fetchQcDoneData(qcPage);
  }, [qcPage, isActiveTab]);

  useEffect(() => {
    if (isActiveTab === "aging") fetchAgingData(agingPage);
  }, [agingPage, isActiveTab]);

  useEffect(() => {
    const el = tableScrollRef.current;
    if (!el) return;

    const onScroll = () => {
      if (loading || isFetchingRef.current) return;

      const { scrollTop, clientHeight, scrollHeight } = el;

      if (scrollHeight - scrollTop <= clientHeight + 100) {
        isFetchingRef.current = true;

        if (isActiveTab === "qc-done" && qcHasMore) {
          setQcPage((p) => p + 1);
        }

        if (isActiveTab === "aging" && agingHasMore) {
          setAgingPage((p) => p + 1);
        }
      }
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [isActiveTab, loading, qcHasMore, agingHasMore]);

  const handleConfirmDelete = async () => {
    setLoading(true);
    try {
      await aging.delete(selectedId);
      notify("Deleted successfully", "success");
      fetchAgingData();
    } catch (error) {
      notify("Failed to delete record", "error");
    } finally {
      setLoading(false);
      setIsDeleteModalOpen(false);
      setSelectedId(null);
    }
  };
  const toDecimal = (v) => {
    if (v === null || v === undefined) return null;
    const s = String(v).trim();
    if (s === "") return null;
    const n = parseFloat(s.replace(/,/g, ""));
    return Number.isFinite(n) ? n : null;
  };
  const pickDetails = (src) => {
    const raw = src?.agingDetails ?? src?.details ?? [];
    if (!Array.isArray(raw) || raw.length === 0) return null;

    return raw.map((d) => ({
      seq_No: d.seq_No ?? 0,
      aging_No: d.aging_No ?? src.aging_No ?? 0,
      batch_Id: d.batch_Id ?? "",
      casting_No: d.casting_No ?? "",
      die_Id: d.die_Id ?? null,
      dieNumber: d.dieNumber ?? "",
      cut_Length: toDecimal(d.cut_Length) ?? 0,
      quantity: toDecimal(d.quantity) ?? 0,
      hardness: toDecimal(d.hardness) ?? 0,
      remark: d.remark ?? "",
      po_No: d.po_No ?? null,
      approved_Pcs: d.approved_Pcs ?? 0,
    }));
  };
  const buildPayload = (src) => {
    const start = toDecimal(src.start_Gas_Reading) ?? 0;
    const end = toDecimal(src.end_Gas_Reading) ?? 0;

    const payload = {
      aging_No: src.aging_No ? Number(src.aging_No) : 0,
      aging_Date: src.aging_Date || null,
      start_Gas_Reading: start,
      end_Gas_Reading: end,
      total_Consumption: toDecimal(src.total_Consumption) ?? end - start,
      temperature: toDecimal(src.temperature) ?? 0,
      shift: src.shift ?? "",
      in_Time: src.in_Time ?? "",
      out_Time: src.out_Time ?? "",
      total_Time: src.total_Time ?? "",
      created_By: src.created_By ?? 1,
    };

    const details = pickDetails(src);
    if (details) payload.agingDetails = details;

    return payload;
  };
  const saveAging = async (source) => {
    const payload = buildPayload(source);
    const res = await aging.saveOrUpdate(payload);

    const newNo = res?.data?.aging_No ?? res?.aging_No ?? payload.aging_No ?? 0;
    payload.aging_No = newNo;
    notify(
      newNo > 0 && (source.aging_No ?? 0) > 0 ? "Updated" : "Saved",
      "success",
    );
    return payload;
  };
  const normalizeAgingForRow = (api) => {
    const details = (api.agingDetails ?? api.details ?? []).map((d) => ({
      seq_No: d.seq_No ?? 0,
      aging_No: d.aging_No ?? api.aging_No ?? 0,
      batch_Id: d.batch_Id ?? "",
      casting_No: d.casting_No ?? "",
      die_Id: d.die_Id ?? null,
      dieNumber: d.dieNumber ?? "",
      cut_Length: toDecimal(d.cut_Length) ?? "",
      quantity: toDecimal(d.quantity) ?? "",
      hardness: toDecimal(d.hardness) ?? "",
      remark: d.remark ?? "",
      po_No: d.po_No ?? "",
      approved_Pcs: d.approved_Pcs ?? 0,
    }));

    return {
      ...api,
      aging_Date: (api.aging_Date || "").split("T")[0] || "",
      start_Gas_Reading: api.start_Gas_Reading ?? "",
      end_Gas_Reading: api.end_Gas_Reading ?? "",
      total_Consumption: api.total_Consumption ?? "",
      temperature: api.temperature ?? "",
      shift: api.shift ?? "",
      in_Time: api.in_Time ?? "",
      out_Time: api.out_Time ?? "",
      total_Time: api.total_Time ?? "",
      status: api.status === true ? "Done" : (api.status ?? ""),
      details,
      agingDetails: details,
    };
  };

  const ensureQtyMatchesApproved = (source) => {
    const orig = source?.agingDetails ?? source?.details ?? [];
    if (!Array.isArray(orig) || !orig.length) {
      return { ok: false, fixed: false, fixedSource: source };
    }
    let changed = false;
    const details = orig.map((d) => {
      const ap = Number(d.approved_Pcs ?? 0);
      const q = Number(d.quantity ?? 0);
      if (!Number.isFinite(ap)) return { ...d };
      if (q !== ap) {
        changed = true;
        return { ...d, quantity: ap };
      }
      return { ...d };
    });

    const fixedSource = { ...source, agingDetails: details, details };
    const ok = details.every(
      (d) => Number(d.quantity ?? 0) === Number(d.approved_Pcs ?? 0),
    );
    return { ok, fixed: changed, fixedSource };
  };

  const handleEdit = async (id) => {
    setLoading(true);
    try {
      const res = await aging.getById(id);
      const entity = res?.data ?? res;
      const record = Array.isArray(entity) ? entity[0] : entity;
      const normalized = normalizeAgingForRow(record || {});
      setFormData(normalized);
      setSelectedQcData(normalized);
      setIsEditing(true);
      setIsModelOpen(true);
    } catch (e) {
      notify(e?.response?.data?.message || "Failed to load record", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleRowSave = async (id) => {
    const row = draftRows[id] ?? isAgingData.find((r) => r.aging_No === id);
    if (!row) return notify("Row not found.", "error");

    setIsSaving(true);
    try {
      await saveAging({ ...row, fromGrid: true });
      setEditingRows((prev) => {
        const n = new Set(prev);
        n.delete(id);
        return n;
      });
      setDraftRows((prev) => {
        const n = { ...prev };
        delete n[id];
        return n;
      });
      fetchAgingData();
    } catch (error) {
      notify("Failed to save row", "error");
    } finally {
      setIsSaving(false);
    }
  };
  const handleSubmit = async () => {
    setIsSaving(true);
    try {
      await saveAging(formData);
      setIsModelOpen(false);
      fetchAgingData();
      fetchQcDoneData();
    } catch (error) {
      notify("Failed to save record", "error");
    } finally {
      setIsSaving(false);
    }
  };

  const buildMarkDoneFromDetail = (detail, aging_No) => {
    if (!detail) return null;
    return {
      Aging_No: Number(aging_No ?? detail.aging_No ?? 0),
      Batch_Id: detail.batch_Id ?? "",
      Casting_No: detail.casting_No ?? "",
      Die_Id: detail.die_Id ?? null,
      Created_By: 1,
    };
  };

  const callMarkDone = async (payload) => {
    if (!payload || !payload.Aging_No || !payload.Batch_Id) {
      notify("Mark Done needs Aging No and Batch Id.", "warning");
      return;
    }
    try {
      await aging.MarkAgingDone(payload);
      notify("Marked as Done", "success");
      fetchAgingData();
      fetchQcDoneData();
    } catch (e) {
      console.error("MarkDone error:", e?.response?.data || e);
      notify(
        e?.response?.data?.message || "Failed to mark production as done",
        "error",
      );
    }
  };
  const toNum = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

  const validateQtyVsApproved = (source) => {
    const details = source?.agingDetails ?? source?.details ?? [];
    const mismatches = [];

    for (let i = 0; i < details.length; i++) {
      const d = details[i];
      const qty = toNum(d.quantity);
      const ap = toNum(d.approved_Pcs);

      if (qty !== ap) {
        mismatches.push({
          index: i,
          batch_Id: d.batch_Id,
          die: d.dieNumber ?? d.die_Id ?? "",
          qty,
          ap,
        });
      }
    }
    return mismatches;
  };

  const saveThenMarkDoneFromSource = async (
    source,
    { closeForm = false } = {},
  ) => {
    const details = source?.agingDetails ?? source?.details ?? [];
    if (!details.length) {
      notify("Add at least one detail before Mark Done.", "warning");
      return;
    }

    const { ok, fixed, fixedSource } = ensureQtyMatchesApproved(source);
    const toSave = fixed ? fixedSource : source;

    if (fixed) {
      notify("Qty adjusted to match Approved Pcs. Saving\u2026", "info");
    }

    const saved = await saveAging(toSave);
    const finalAgingNo = saved.aging_No;
    const first = {
      ...((toSave.agingDetails ?? toSave.details ?? [])[0] || {}),
      aging_No: finalAgingNo,
    };

    const { ok: okAfter } = ensureQtyMatchesApproved(saved);
    if (!okAfter) {
      notify(
        "Qty must equal Approved Pcs for all details before Mark Done.",
        "error",
      );
      return;
    }

    const mdPayload = buildMarkDoneFromDetail(first, finalAgingNo);
    await callMarkDone(mdPayload);

    if (closeForm) setIsModelOpen(false);
    fetchQcDoneData();
  };
  const handleMarkDoneRow = async (row) => {
    setIsSaving(true);
    try {
      const source = draftRows[row.aging_No] ? draftRows[row.aging_No] : row;
      const mismatches = validateQtyVsApproved(source);

      const saved = await saveAging(source);

      const recheck = validateQtyVsApproved(saved);
      if (recheck.length) {
        notify(
          "Validation failed after save. Please re-check quantities.",
          "error",
        );
        return;
      }

      const finalAgingNo = saved.aging_No;
      const firstDetail = (saved.agingDetails ?? saved.details ?? [])[0];
      const mdPayload = buildMarkDoneFromDetail(firstDetail, finalAgingNo);
      await callMarkDone(mdPayload);
    } catch (error) {
      notify("Failed to mark done", "error");
    } finally {
      setIsSaving(false);
    }
  };

  const handleFieldChange = (field, value) => {
    setSelectedQcData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleAdd = async () => {
    if (selectedSeqs.length === 0) {
      notify("Please select at least one QC-Done row.", "warning");
      return;
    }

    setAdding(true);
    try {
      const payload = selectedSeqs.map(Number);
      const res = await aging.AddToAging(payload);
      const items = Array.isArray(res) ? res : res?.data || [];

      const rows = items.map((x) => ({
        batch_Id: x.batch_Id ?? "",
        die_Id: x.die_Id ?? "",
        dieNumber: x.dieNumber ?? "",
        casting_No: x.casting_No ?? "",
        cut_Length: x.cut_Length ?? "",
        po_No: String(x.order_No ?? x.so_No ?? ""),
        approved_Pcs: Number(x.approved_Pcs ?? 0),
        quantity: "",
        hardness: "",
        remark: "",
      }));
      setFormData((prev) => {
        const base =
          prev?.aging_No != null
            ? prev
            : {
              aging_No: 0,
              aging_Date: "",
              start_Gas_Reading: "",
              end_Gas_Reading: "",
              total_Consumption: "",
              temperature: "",
              shift: "",
              in_Time: "",
              out_Time: "",
              total_Time: "",
              created_By: userId,
              agingDetails: [],
            };
        return { ...base, agingDetails: rows };
      });

      setSelectedQcData((prev) => ({ ...(prev || {}), agingDetails: rows }));
      setIsActiveTab("aging");
      setIsModelOpen(true);
      setIsEditing(false);
    } catch (e) {
      notify(
        e?.response?.data?.message || e?.message || "Failed to Add to Aging",
        "error",
      );
    } finally {
      setAdding(false);
    }
  };

  const columns = [
    {
      key: "select",
      disableSort: true,
      label: (
        <input
          type="checkbox"
          checked={
            isQcDoneData.length > 0 &&
            isQcDoneData.every((r) => selectedSeqs.includes(r.seq_No))
          }
          onChange={(e) => {
            if (e.target.checked) {
              const pageIds = isQcDoneData.map((r) => r.seq_No);
              setSelectedSeqs((prev) =>
                Array.from(new Set([...prev, ...pageIds])),
              );
            } else {
              const pageSet = new Set(isQcDoneData.map((r) => r.seq_No));
              setSelectedSeqs((prev) => prev.filter((id) => !pageSet.has(id)));
            }
          }}
          className="w-4 h-4 text-primary cursor-pointer"
        />
      ),
      render: (_v, row) => (
        <input
          type="checkbox"
          checked={selectedSeqs.includes(row.seq_No)}
          onChange={(e) => {
            const id = Number(row.seq_No);
            setSelectedSeqs((prev) =>
              e.target.checked ? [...prev, id] : prev.filter((x) => x !== id),
            );
          }}
          className="w-4 h-4 text-primary cursor-pointer"
        />
      ),
    },

    { key: "order_No", label: "ORDER" },
    { key: "batch_Id", label: "BATCH" },
    { key: "casting_No", label: "CASTING" },
    { key: "dieNumber", label: "DIE" },
    { key: "approved_Pcs", label: "APPR PCS" },
    { key: "current_Weight", label: "CURRENT WT" },
    { key: "cut_Length", label: "CUT LENGTH" },
    {
      key: "dispatch_Date",
      label: "DISPATCH DATE",
      render: (value) => formatDate(value),
    },
    {
      key: "packing_Instructions",
      label: "PACKING INST",
    },
    { key: "general_Notes", label: "GENERAL NOTES" },
  ];

  const renderCell = (
    row,
    field,
    { type = "text", step, align = "right" } = {},
  ) => {
    const editable = editingRows.has(row.aging_No);
    const value = row[field] ?? "";

    if (editable) {
      return (
        <input
          type={type}
          step={step}
          className={`w-full bg-white border border-blue-400 rounded px-1.5 py-1 outline-none focus:ring-1 focus:ring-blue-500 text-[12px]  text-${align}`}
          value={value}
          onChange={(e) => changeDraft(row.aging_No, field, e.target.value)}
        />
      );
    }

    return (
      <span
        className={`block px-2 py-1 text-slate-700 font-medium text-${align}`}
      >
        {value || value === 0 ? value : "-"}
      </span>
    );
  };
  return (
    <div className="flex flex-col h-full bg-white font-plus relative">
      {loading && <Loader centered />}
      <RegistryHeader title="Aging Operations">
        <div className="flex bg-gray-100 p-1 rounded-sm gap-1 shrink-0" data-tour="aging-tabs">
          <button
            onClick={() => handleTabChange("qc-done")}
            className={`px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all ${isActiveTab === "qc-done"
              ? "bg-primary text-white  #3F80F7]/20"
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-200/50"
              }`}
          >
            Aging Pending
          </button>
          <button
            onClick={() => handleTabChange("aging")}
            className={`px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all ${isActiveTab === "aging"
              ? "bg-primary text-white  #3F80F7]/20"
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-200/50"
              }`}
          >
            Aging Done
          </button>
        </div>

        <button
          onClick={() => setIsTourOpen(true)}
          className="flex items-center gap-2 px-4 py-2.5 h-[42px] text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
          title="Start Onboarding Tour"
        >
          <Info size={14} className="shrink-0" />
          Guide
        </button>

        <div className="relative w-full sm:w-80 group" data-tour="aging-search">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none group-focus-within:text-primary">
            <LiaSearchSolid size={18} className="text-gray-400 transition-colors" />
          </div>
          <input
            type="text"
            className="block w-full pl-12 pr-10 py-2.5 bg-gray-50 border border-gray-200 text-gray-900 text-[11px] font-black uppercase tracking-[2px] focus:border-primary focus:bg-white focus:outline-none transition-all placeholder:text-gray-300"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery("")}
              className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-red-500 transition-colors"
            >
              <MdClose size={18} />
            </button>
          )}
        </div>

        {isActiveTab === "qc-done" && (
          <Button
            disabled={selectedSeqs.length === 0 || adding}
            onClick={handleAdd}
            icon={HiOutlinePlus}
            className="whitespace-nowrap"
            loading={adding}
            data-tour="add-aging-btn"
          >
            {adding ? "INITIALIZING..." : `ADD AGING (${selectedSeqs.length})`}
          </Button>
        )}
      </RegistryHeader>

      <div className="px-8 pt-0 pb-4 flex-1 overflow-hidden flex flex-col bg-white">
        <div
          ref={tableScrollRef}
          className="relative flex-1 overflow-auto border border-gray-200 bg-white"
          data-tour="aging-table"
        >
          {isActiveTab === "qc-done" ? (
            <div className="min-w-max bg-white">
              <Table
                columns={columns}
                data={isQcDoneData}
                showActions={false}
                tableClassName="text-[12px] border-none font-bold"
              />
            </div>
          ) : (
            <div className="min-w-max ">
              <Table
                columns={[
                  { key: "aging_No", label: "NO.", align: "center", className: "font-bold text-slate-800 border-r border-gray-100" },
                  { key: "aging_Date", label: "DATE", align: "center", className: "font-semibold text-slate-800 border-r border-gray-100", render: (val) => formatDate(val) },
                  { key: "start_Gas_Reading", label: "START GAS", align: "right", className: "border-r border-gray-100", render: (val, row) => renderCell(row, "start_Gas_Reading", { align: "right" }) },
                  { key: "end_Gas_Reading", label: "END GAS", align: "right", className: "border-r border-gray-100", render: (val, row) => renderCell(row, "end_Gas_Reading", { align: "right" }) },
                  { key: "total_Consumption", label: "CONS.", align: "right", className: "font-bold text-primary border-r border-gray-100", render: (val, row) => renderCell(row, "total_Consumption", { align: "right" }) },
                  { key: "temperature", label: "TEMP.", align: "right", className: "border-r border-gray-100", render: (val, row) => renderCell(row, "temperature", { align: "right" }) },
                  { key: "shift", label: "SHIFT", align: "left", className: "border-r border-gray-100", render: (val, row) => renderCell(row, "shift", { align: "left" }) },
                  { key: "in_Time", label: "IN TIME", align: "right", className: "border-r border-gray-100", render: (val, row) => renderCell(row, "in_Time", { type: "time", align: "right" }) },
                  { key: "out_Time", label: "OUT TIME", align: "right", className: "border-r border-gray-100", render: (val, row) => renderCell(row, "out_Time", { type: "time", align: "right" }) },
                  { key: "total_Time", label: "TOTAL", align: "right", className: "font-bold text-primary border-r border-gray-100", render: (val, row) => renderCell(row, "total_Time", { type: "time", align: "right" }) },
                  {
                    key: "status", label: "STATUS", align: "center", className: "border-r border-gray-100",
                    render: (val) => (
                      <span className={`px-2 py-0.5 text-[10px] font-bold uppercase tracking-tighter border ${val === "Complete" ? "bg-green-50 text-green-700 border-green-200" : "bg-blue-50 text-blue-700 border-blue-200"}`}>
                        {val}
                      </span>
                    )
                  },
                  {
                    key: "actions", label: "ACTIONS", align: "center",
                    render: (val, row) => {
                      const id = row.aging_No;
                      const isEditingRow = editingRows.has(id);
                      const d = isEditingRow ? (draftRows[id] ?? row) : row;
                      return (
                        <div className="flex items-center justify-center gap-2">
                          {!isEditingRow ? (
                            <>
                              <button onClick={() => handleEdit(row.aging_No)} className="px-2.5 py-1 border border-gray-200 text-blue-600 hover:bg-blue-50 transition-all text-[10px] font-black uppercase tracking-wider rounded-none">Edit</button>
                              <button onClick={() => handleMarkDoneRow(row)} className="px-2.5 py-1 border border-gray-200 text-green-600 hover:bg-green-50 transition-all text-[10px] font-black uppercase tracking-wider rounded-none">Mark Done</button>
                            </>
                          ) : (
                            <>
                              <button onClick={() => handleRowSave(d.aging_No)} className="px-2.5 py-1 border border-gray-200 text-green-600 hover:bg-green-50 transition-all text-[10px] font-black uppercase tracking-wider rounded-none">Save</button>
                              <button onClick={() => cancelEdit(id)} className="px-2.5 py-1 border border-gray-200 text-red-600 hover:bg-red-50 transition-all text-[10px] font-black uppercase tracking-wider rounded-none">Cancel</button>
                            </>
                          )}
                        </div>
                      );
                    }
                  }
                ]}
                data={isAgingData}
                showActions={false}
                rowIdField="aging_No"
                renderExpansion={(row) => (
                  <div className="overflow-hidden">
                    <Table
                      columns={[
                        { key: "batch_Id", label: "Batch", align: "left", className: "font-bold border-r border-gray-100" },
                        { key: "cut_Length", label: "Cut Length", align: "left", className: "border-r border-gray-100" },
                        { key: "quantity", label: "Qty", align: "left", className: "border-r border-gray-100" },
                        { key: "hardness", label: "Hardness", align: "left", className: "border-r border-gray-100" },
                        { key: "remark", label: "Remark", align: "left", className: "italic text-slate-400" },
                      ]}
                      data={row.agingDetails}
                      showActions={false}
                      tableClassName="text-[11px] border-none"
                    />
                  </div>
                )}
                getRowClassName={(row, idx) => editingRows.has(row.aging_No) ? "bg-blue-50/50" : ""}
                tableClassName="text-[12px] border-none"
              />
            </div>
          )}
        </div>
      </div>

      <div data-tour="aging-footer">
        {(() => {
          const totalPcs = isActiveTab === "qc-done"
            ? isQcDoneData.reduce((sum, row) => sum + Number(row.approved_Pcs || 0), 0)
            : isAgingData.length;
          const allottedPcs = isQcDoneData
            .filter((r) => selectedSeqs.includes(r.seq_No))
            .reduce((sum, row) => sum + Number(row.approved_Pcs || 0), 0);

          const footerItems = [
            {
              label: "TOTAL PENDING PCS",
              value: totalPcs.toLocaleString(),
              suffix: "PCS",
              color: totalPcs > 0 ? "text-primary" : "text-gray-300"
            }
          ];

          if (isActiveTab === "qc-done") {
            footerItems.push({
              label: "SELECTED PCS",
              value: allottedPcs.toLocaleString(),
              suffix: "PCS",
              color: allottedPcs > 0 ? "text-primary" : "text-gray-300"
            });
          }

          return <CalculationFooter items={footerItems} />;
        })()}
      </div>

      <TourGuide
        isOpen={isTourOpen}
        steps={AgingTourSteps}
        title="Aging Guide"
        model="Aging Module"
        onClose={() => {
          setIsTourOpen(false);
          handleTourComplete();
        }}
      />

      {isModelOpen && formData && (
        <AgingForm
          data={selectedQcData}
          onChange={handleFieldChange}
          setFormData={setFormData}
          formData={formData}
          onSubmit={handleSubmit}
          onClose={() => {
            setIsModelOpen(false);
            setSelectedQcData(null);
            setFormData({
              aging_No: 0,
              aging_Date: "",
              start_Gas_Reading: "",
              end_Gas_Reading: "",
              total_Consumption: "",
              temperature: "",
              shift: "",
              in_Time: "",
              out_Time: "",
              total_Time: "",
              created_By: userId,
              agingDetails: [],
            });
          }}
          refreshList={fetchQcDoneData}
          refreshAgingList={fetchAgingData}
          onMarkDone={() =>
            saveThenMarkDoneFromSource(formData, { closeForm: true })
          }
          isSaving={isSaving}
        />
      )}

      <ConfirmDeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
      />

      {errorModalOpen && (
        <ErrorModal
          message={errorMessage}
          subMessage={errorSubMessage}
          onClose={() => setErrorModalOpen(false)}
        />
      )}
    </div>
  );
};

export default Aging;
